export default "__VITE_ASSET__HZ5fN7TF__"